interface Props {
  language: "tr" | "en"
  onDismiss: () => void
}

export const SoftWarning = ({ language, onDismiss }: Props) => {
  const message = language === "tr"
    ? "Bu ifade endişe verici."
    : "This expression is concerning."

  return (
    <div className="soft-warning" style={{ marginTop: "10px" }}>
      <span>{message}</span>
      <button
        onClick={onDismiss}
        style={{
          background: "transparent",
          border: "none",
          color: "#FCA5A5",
          cursor: "pointer",
          fontSize: "16px",
          padding: "0 4px",
          opacity: 0.7
        }}
      >
        ×
      </button>
    </div>
  )
}